module.exports = "<div class=grid-header-view></div> <div class=grid-content-view></div> <div class=js-nocolumns-view-region></div>";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/grid.hbs
// module id = 706
// module chunks = 0